/* ============================================================
   KROQ — Comportements de la carte produit
   Utilisé par : snippets/kroq-product-card.liquid

   Ce fichier corrige deux commandes qui étaient rendues sans aucun
   gestionnaire :

   · le bouton favoris annonçait « Ajouter aux favoris » et ne faisait
     rien du tout — un contrôle focalisable qui promet une action sans
     l'exécuter ;
   · l'ajout rapide rechargeait la page vers /cart au lieu d'ouvrir le
     panier latéral du thème.

   Amélioration progressive : sans JavaScript, le formulaire d'ajout
   reste un POST natif parfaitement fonctionnel.
   ============================================================ */

(function () {
  'use strict';

  // Le script peut être chargé par plusieurs sections : on ne l'exécute
  // qu'une fois.
  if (window.__kroqCardInit) return;
  window.__kroqCardInit = true;

  var STORAGE_KEY = 'kroq:wishlist';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ── Favoris (localStorage, aucun compte requis) ──────────────────
     Le mode navigation privée de Safari fait échouer localStorage :
     toutes les lectures et écritures sont donc protégées. */
  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* Stockage indisponible : l'état reste valable pour la page. */
    }
  }

  function syncWishlistButton(button, active) {
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? button.dataset.labelRemove : button.dataset.labelAdd;
    if (label) button.setAttribute('aria-label', label);
  }

  function initWishlist(scope) {
    var buttons = scope.querySelectorAll('[data-kroq-wish]:not([data-kroq-wish-ready])');
    if (!buttons.length) return;
    var saved = readWishlist();

    buttons.forEach(function (button) {
      button.setAttribute('data-kroq-wish-ready', '1');
      var id = button.getAttribute('data-kroq-wish');
      syncWishlistButton(button, saved.indexOf(id) !== -1);

      button.addEventListener('click', function () {
        var ids = readWishlist();
        var at = ids.indexOf(id);
        if (at === -1) {
          ids.push(id);
        } else {
          ids.splice(at, 1);
        }
        writeWishlist(ids);
        syncWishlistButton(button, at === -1);
      });
    });
  }

  /* ── Ajout rapide ─────────────────────────────────────────────── */
  function initQuickAdd(scope) {
    var forms = scope.querySelectorAll('[data-kroq-quickadd]:not([data-kroq-quickadd-ready])');

    forms.forEach(function (form) {
      form.setAttribute('data-kroq-quickadd-ready', '1');
      var button = form.querySelector('button[type="submit"]');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (button) button.disabled = true;

        fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new FormData(form),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(function (cart) {
            /* Même événement que la fiche produit : le panier latéral du
               thème s'ouvre et se met à jour. */
            (button || document).dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'kroq-card',
                  data: {
                    source: 'kroq-card',
                    itemCount: cart ? cart.item_count : 0,
                    didError: false,
                  },
                },
              })
            );
          })
          .catch(function () {
            /* En cas d'échec réseau, on retombe sur le POST natif plutôt
               que de laisser le client sans retour. */
            form.submit();
          })
          .finally(function () {
            if (button) button.disabled = false;
          });
      });
    });
  }

  function init(scope) {
    var target = scope || document;
    initWishlist(target);
    initQuickAdd(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Grilles rechargées via la Section Rendering API (filtres, pagination
     infinie, éditeur de thème). */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
  document.addEventListener('cart:update', function () {
    init(document);
  });
})();
